import { render, staticRenderFns } from "./MetaTable.vue?vue&type=template&id=f4c5f52e&"
import script from "./MetaTable.vue?vue&type=script&lang=ts&"
export * from "./MetaTable.vue?vue&type=script&lang=ts&"
import style0 from "./MetaTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports